import "./CheckoutProduct.css";
import { useStateValue } from "./StateProvider";
function CheckoutProduct({ id, image1_url, title, price, hideButton }) {
  const [{ basket }, dispatch] = useStateValue();
  const removeFromBasket = () => {
    //remove the item from basket
    dispatch({ type: "REMOVE_FROM_BASKET", id: id });
  };

  return (
    <div className="checkoutProduct">
      <img className="checkoutProduct__image" src={image1_url} alt="imag" />
      <div className="checkoutProduct__info" key={id}>
        <h6 className="checkoutProduct__title">{title}</h6>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        ></div>
        <p className="checkoutProduct__price">
          <small> $ </small>
          <strong> {price} </strong>
        </p>
        {!hideButton && (
          <button onClick={removeFromBasket}> Remove from Cart </button>
        )}
      </div>
    </div>
  );
}

export default CheckoutProduct;
